module.exports = __webpack_public_path__ + "static/media/Bestari.00b2c39f.png";